module.exports = __webpack_public_path__ + "media/notification_B2B_message.fa9ab470.mp3";